import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { Reveal } from "@/components/demo/lib/Reveal";
import { IMG } from "@/components/demo/lib/images";

const WA = "41765008176";

const TREATMENTS = [
  { n: "01", name: "Le Grand Soin Viso", dur: "120 min", price: "CHF 290", desc: "Trattamento couture viso e collo, diagnosi cutanea, massaggio kobido, maschera bio-cellulare." },
  { n: "02", name: "Couleur Atelier", dur: "180 min", price: "CHF 380", desc: "Studio colorimetrico personalizzato, balayage à la main, trattamento Olaplex, piega su misura." },
  { n: "03", name: "Lumière Faciale", dur: "75 min", price: "CHF 220", desc: "Microdermoabrasione, LED rosso/blu, infusione vitamina C, finish glow per pelli stressate." },
  { n: "04", name: "Massage Royal", dur: "90 min", price: "CHF 240", desc: "Massaggio corpo intero con oli essenziali biologici, rituale aromaterapico esclusivo della maison." },
  { n: "05", name: "Brow Architect", dur: "45 min", price: "CHF 120", desc: "Disegno geometrico delle sopracciglia, tinta vegetale, laminazione professionale." },
];

const TEAM = [
  { n: "Camille Aubert", r: "Direttrice & Skin Therapist", q: "La pelle racconta sempre una storia. Il mio compito è ascoltarla prima di intervenire.", img: IMG.beauty.team1 },
  { n: "Léa Bianchi", r: "Master Colorist", q: "Ogni colore è un'opera unica. Non esistono due donne con la stessa luce.", img: IMG.beauty.team2 },
  { n: "Élise Vasseur", r: "Make-up Artist", q: "Il make-up rivela ciò che c'è già. Non aggiunge, sottrae il superfluo.", img: IMG.beauty.team3 },
];

const GALLERY = [
  IMG.beauty.editorial1, IMG.beauty.editorial2, IMG.beauty.editorial3, IMG.beauty.editorial4,
  IMG.beauty.editorial5, IMG.beauty.editorial6, IMG.beauty.editorial7, IMG.beauty.editorial8,
];

function MaisonBelle() {
  const [drag, setDrag] = useState(50);

  return (
    <div className="min-h-screen bg-[#f4ede2] text-stone-900 antialiased overflow-x-hidden">
      <style>{`
        .ff-display { font-family: 'Cormorant Garamond', 'Times New Roman', serif; font-weight: 300; }
        body { font-family: 'Inter', sans-serif }
      `}</style>

      <header className="fixed top-0 left-0 right-0 z-50 px-5 sm:px-12 py-4 sm:py-6 mix-blend-difference text-white">
        <div className="flex md:grid md:grid-cols-3 items-center justify-between gap-4">
          <nav className="hidden md:flex gap-8 text-[10px] tracking-[0.35em] uppercase">
            <a href="#treatments">Trattamenti</a><a href="#team">Équipe</a><a href="#journal">Journal</a>
          </nav>
          <div className="ff-display text-2xl sm:text-3xl md:text-center tracking-wide whitespace-nowrap">Maison Belle</div>
          <div className="md:text-right text-[10px] tracking-[0.35em] uppercase"><a href="#book">Prenota</a></div>
        </div>
      </header>

      {/* HERO */}
      <section className="min-h-screen grid lg:grid-cols-12 pt-24 pb-12">
        <div className="lg:col-span-5 px-6 sm:px-12 flex flex-col justify-end pb-12 lg:pb-24">
          <Reveal>
            <div className="text-[10px] tracking-[0.4em] uppercase mb-6 text-stone-500">N° 24 — Édition Couture</div>
            <h1 className="ff-display text-[14vw] lg:text-[7.5vw] leading-[0.9] tracking-tight break-words">
              Bellezza<br />su<br /><em>misura.</em>
            </h1>
            <p className="mt-10 max-w-xs text-stone-600 leading-relaxed">
              Un atelier dove la cura della pelle incontra l'artigianato. A Lugano dal 2014, per una clientela che cerca discrezione e risultati visibili.
            </p>
            <a href="#book" className="mt-10 inline-block text-[10px] tracking-[0.4em] uppercase border-b border-stone-900 pb-2 self-start hover:text-stone-600 transition">→ Prenota una consulenza</a>
          </Reveal>
        </div>
        <div className="lg:col-span-7 relative min-h-[60vh] lg:min-h-0">
          <img src={IMG.beauty.hero} alt="Editoriale Maison Belle — ritratto in studio" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute bottom-6 right-6 text-white text-[10px] tracking-[0.3em] uppercase">Ph. — Studio Lumière</div>
        </div>
      </section>

      {/* MARQUEE */}
      <section className="border-y border-stone-900/10 overflow-hidden py-5">
        <div className="ff-display text-3xl sm:text-4xl whitespace-nowrap animate-[marquee_38s_linear_infinite]">
          {Array.from({ length: 3 }).map((_, i) => (
            <span key={i} className="px-10 italic">Augustinus Bader · Biologique Recherche · Dr. Sebagh · La Mer · Sisley Paris · 111SKIN ·</span>
          ))}
        </div>
      </section>

      {/* TREATMENTS */}
      <section id="treatments" className="px-6 sm:px-12 py-32">
        <div className="max-w-7xl mx-auto">
          <Reveal>
            <div className="grid lg:grid-cols-[1fr_2fr] gap-12 mb-20">
              <div className="text-[10px] tracking-[0.4em] uppercase text-stone-500">Cap. I — Trattamenti viso e corpo</div>
              <h2 className="ff-display text-6xl lg:text-8xl leading-[0.9] break-words">I rituali<br /><em>della casa.</em></h2>
            </div>
          </Reveal>
          <div className="divide-y divide-stone-900/15">
            {TREATMENTS.map((t, i) => (
              <Reveal key={t.n} delay={i * 60}>
                <div className="grid lg:grid-cols-[60px_1fr_1fr_120px_140px] gap-6 py-10 items-baseline">
                  <div className="ff-display text-3xl italic text-stone-400">{t.n}</div>
                  <div className="ff-display text-3xl lg:text-4xl">{t.name}</div>
                  <div className="text-sm text-stone-600 leading-relaxed">{t.desc}</div>
                  <div className="text-xs tracking-[0.25em] uppercase text-stone-500">{t.dur}</div>
                  <div className="text-right ff-display text-2xl">{t.price}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* BEFORE / AFTER */}
      <section className="px-6 sm:px-12 py-32 bg-stone-900 text-stone-100">
        <div className="max-w-6xl mx-auto">
          <Reveal>
            <div className="text-[10px] tracking-[0.4em] uppercase text-stone-400 mb-6">Cap. II — Prima / Dopo</div>
            <h2 className="ff-display text-5xl lg:text-7xl mb-16 max-w-2xl break-words">Risultati<br /><em>che parlano da soli.</em></h2>
          </Reveal>
          <div className="relative aspect-[16/10] overflow-hidden select-none cursor-ew-resize" onMouseMove={(e) => {
            const r = e.currentTarget.getBoundingClientRect();
            setDrag(Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100)));
          }} onTouchMove={(e) => {
            const r = e.currentTarget.getBoundingClientRect();
            setDrag(Math.max(0, Math.min(100, ((e.touches[0].clientX - r.left) / r.width) * 100)));
          }}>
            <img src={IMG.beauty.editorial2} alt="Prima del trattamento" className="absolute inset-0 w-full h-full object-cover" style={{ filter: "grayscale(0.7) contrast(0.85)" }} />
            <div className="absolute inset-0 overflow-hidden" style={{ clipPath: `inset(0 0 0 ${drag}%)` }}>
              <img src={IMG.beauty.editorial3} alt="Dopo il trattamento" className="w-full h-full object-cover" />
            </div>
            <div className="absolute top-0 bottom-0 w-px bg-white" style={{ left: `${drag}%` }}>
              <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 h-12 w-12 rounded-full bg-white grid place-items-center text-stone-900 text-xl">⇄</div>
            </div>
            <div className="absolute top-6 left-6 text-[10px] tracking-[0.3em] uppercase">PRIMA</div>
            <div className="absolute top-6 right-6 text-[10px] tracking-[0.3em] uppercase">DOPO</div>
          </div>
        </div>
      </section>

      {/* TEAM */}
      <section id="team" className="px-6 sm:px-12 py-32">
        <div className="max-w-7xl mx-auto">
          <Reveal>
            <h2 className="ff-display text-6xl lg:text-8xl mb-20 break-words"><em>L'équipe</em></h2>
          </Reveal>
          <div className="grid sm:grid-cols-3 gap-x-8 gap-y-16">
            {TEAM.map((m, i) => (
              <Reveal key={m.n} delay={i * 80}>
                <div className="aspect-[3/4] bg-stone-200 mb-5 overflow-hidden">
                  <img src={m.img} alt={`${m.n} — ritratto in atelier`} className="w-full h-full object-cover grayscale hover:grayscale-0 transition duration-700" />
                </div>
                <div className="ff-display text-3xl">{m.n}</div>
                <div className="text-[10px] tracking-[0.35em] uppercase text-stone-500 mt-2">{m.r}</div>
                <p className="ff-display italic text-xl text-stone-600 mt-4">"{m.q}"</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* PRESS */}
      <section className="px-6 sm:px-12 py-24 border-t border-stone-900/15">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-[auto_1fr] gap-12 items-center">
          <div className="text-[10px] tracking-[0.4em] uppercase text-stone-500">— Hanno parlato di noi</div>
          <div className="flex flex-wrap gap-x-12 gap-y-6 ff-display text-2xl text-stone-400">
            {["Vogue Italia", "Marie Claire", "Bilan", "Femina", "Harper's Bazaar"].map((p) => <span key={p} className="italic">{p}</span>)}
          </div>
        </div>
      </section>

      {/* JOURNAL / IG WALL */}
      <section id="journal" className="px-6 sm:px-12 py-32 border-t border-stone-900/15">
        <div className="max-w-7xl mx-auto">
          <Reveal>
            <div className="flex justify-between items-end mb-12">
              <h2 className="ff-display text-5xl lg:text-7xl break-words"><em>Il nostro journal</em></h2>
              <a href="#" className="text-[10px] tracking-[0.4em] uppercase border-b border-stone-900 pb-1">@maisonbelle.ch</a>
            </div>
          </Reveal>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
            {GALLERY.map((src, i) => (
              <Reveal key={i} delay={i * 30}>
                <div className={`overflow-hidden ${i === 2 ? "row-span-2 aspect-[1/2]" : "aspect-square"}`}>
                  <img src={src} alt={`Maison Belle — scatto editoriale ${i + 1}`} className="w-full h-full object-cover hover:scale-105 transition duration-700" />
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* TESTIMONIAL */}
      <section className="px-6 sm:px-12 py-32 border-t border-stone-900/15">
        <div className="max-w-4xl mx-auto text-center">
          <Reveal>
            <div className="ff-display text-9xl italic text-stone-300 leading-none">"</div>
            <blockquote className="ff-display text-3xl lg:text-5xl leading-[1.15] -mt-8 break-words">
              È l'unico posto a sud delle Alpi dove vado per il mio rituale mensile. <em className="text-stone-500">Discrezione, savoir-faire, atmosfera. Una piccola maison parigina nel cuore di Lugano.</em>
            </blockquote>
            <div className="mt-10 ff-display text-xl italic">— Anna F. · Cliente da 7 anni</div>
          </Reveal>
        </div>
      </section>

      {/* BOOK */}
      <section id="book" className="px-6 sm:px-12 py-32 border-t border-stone-900/15 bg-stone-900 text-stone-100">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="ff-display text-5xl lg:text-7xl mb-6 break-words"><em>Prenota</em><br />una consulenza.</h2>
          <p className="text-stone-400 mb-10">Consulenza personalizzata in atelier. Risposta entro 4 ore.</p>
          <a href={`https://wa.me/${WA}?text=${encodeURIComponent("Buongiorno Maison Belle, vorrei prenotare una consulenza.")}`} className="inline-block bg-stone-100 text-stone-900 px-10 py-5 text-[10px] tracking-[0.4em] uppercase font-bold hover:bg-amber-200 transition">Continua su WhatsApp</a>
          <div className="mt-12 text-[10px] tracking-[0.3em] uppercase text-stone-500">Via Pretorio 24 · 6900 Lugano · Mar–Sab 10:00–19:00</div>
        </div>
      </section>

      <footer className="px-6 sm:px-12 py-10 text-[10px] tracking-[0.3em] uppercase text-stone-500 bg-stone-900 border-t border-stone-700/30">
        <div className="max-w-7xl mx-auto flex flex-wrap justify-between gap-4">
          <div>Maison Belle · Atelier de beauté · Fondata nel 2014</div>
          <div>Demo FlashWeb · <Link to="/" className="underline">flash-web.ch</Link></div>
        </div>
      </footer>

      <style>{`@keyframes marquee { 0% { transform: translateX(0) } 100% { transform: translateX(-33.333%) } }`}</style>
    </div>
  );
}

export const Route = createFileRoute("/demo/maison-belle")({
  head: () => ({
    meta: [
      { title: "Maison Belle — Atelier di bellezza a Lugano (Demo FlashWeb)" },
      { name: "description", content: "Trattamenti viso, hair couture e bellezza su misura in un atelier di lusso a Lugano. Prenota una consulenza personalizzata." },
      { name: "robots", content: "noindex, follow" },
    ],
  }),
  component: MaisonBelle,
});
